const QuestionMarkSvg = () => {

    return (
        <div 
        // style={{ height: "35px" }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M10 5C10 7.76204 7.76123 10 5 10C2.23877 10 0 7.76204 0 5C0 2.23958 2.23877 0 5 0C7.76123 0 10 2.23958 10 5ZM5.13417 1.65323C4.03544 1.65323 3.33468 2.11607 2.7844 2.93867C2.7131 3.04524 2.73696 3.18897 2.83913 3.26645L3.53871 3.7969C3.64365 3.87647 3.79317 3.85754 3.8747 3.75411C4.23486 3.2973 4.48181 3.0324 5.03 3.0324C5.44187 3.0324 5.95133 3.29748 5.95133 3.69688C5.95133 3.99881 5.70208 4.15387 5.2954 4.38188C4.82113 4.64774 4.19355 4.97865 4.19355 5.80645V5.8871C4.19355 6.02071 4.30187 6.12903 4.43548 6.12903H5.56452C5.69812 6.12903 5.80645 6.02071 5.80645 5.8871V5.86022C5.80645 5.28639 7.48359 5.2625 7.48359 3.70968C7.48359 2.54028 6.27058 1.65323 5.13417 1.65323ZM5 6.65323C4.48861 6.65323 4.07258 7.06925 4.07258 7.58065C4.07258 8.09202 4.48861 8.50806 5 8.50806C5.51139 8.50806 5.92742 8.09202 5.92742 7.58065C5.92742 7.06925 5.51139 6.65323 5 6.65323Z" fill="#C4C4C4" />
            </svg>
        </div>
    );
};

export default QuestionMarkSvg;
